import Logos from '../../../assets/acceptance-letter/proceeding logos.svg';
import Signature from '../../../assets/acceptance-letter/signature.png';
import UNAM from '../../../assets/acceptance-letter/unam.png';
import PropTypes from 'prop-types';
import Background from '../../../assets/acceptance-letter/Proceeding sheet.png';

export const AcceptanceLetterComponent = ({ abstract }) => {
  const Print = () => {
    //console.log('print');
    let printContents = document.getElementById('printablediv').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    <>
      <button className="print-button" onClick={Print}>
        <span className="material-symbols-outlined">print</span> Imprimir
      </button>
      <div id="printablediv" className="acceptance-letter-wrapper">
        <div className="acceptance-letter-logos-wrapper">
          <img src={Logos} alt="Proceeding logos" />
        </div>
        <p className="acceptance-letter-title">CARTA DE ACEPTACIÓN</p>
        <div className="acceptance-letter-text-wrapper">
          <p>
            Estimado/a{' '}
            <strong>
              {abstract.authors[0].lastName} {abstract.authors[0].name[0]}.,
            </strong>
          </p>
          <p>
            En nombre del Comité Organizador, es un placer informarle que el resumen
            titulado:
          </p>
          <p>
            <strong>
              {abstract.code ? abstract.code : ''}: “{abstract.title}.”
            </strong>
          </p>
          <p>
            Ha sido aceptado como presentación {abstract.accepted} en el Simposio de Nanociencia
            y Nanomateriales 2024 que se llevará a cabo en Ensenada, Baja California del 13 al 17 de mayo de 2024.
          </p>
          {abstract.presentation_type === 'oral' ? (
            <p>
              Te invitamos a registrarte en el sitio web antes del 15 de abril de 2024. En el caso de
              presentación oral, si no te registras antes del 1 de mayo tu trabajo podría cambiarse a
              póster. Por favor envía un correo con confirmación de tu presencia ya que esta es una
              presentación presencial.
            </p>
          ) : null}

          <p>Sincerely,</p>
          <div className="acceptance-letter-signature-wrapper">
            <img className="signature" src={Signature} alt="Signature" />
          </div>
          <img className="unam" src={UNAM} alt="UNAM" />
          <img src={Background} className="background-img" />
        </div>
      </div>
    </>
  );
};

AcceptanceLetterComponent.propTypes = {
  abstract: PropTypes.any.isRequired,
};
